import React from "react";
import { NumericFormat } from "react-number-format";
import { Box, Button, TextField } from "@mui/material";

const QuinInputNum = ({
  disabled = false,
  selectedValue,
  handleChangeValue,
  handleAdd,
  buttonLabel = "+",
  buttonDisabled,
  readOnly = false,
  placeholder = "12",
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      width="100%"
      onClick={handleClick}
    >
      <Box flex={2}>
        {readOnly ? (
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            value={selectedValue}
            InputProps={{ readOnly: true }}
          />
        ) : (
          <NumericFormat
            thousandSeparator=" "
            decimalScale={2}
            decimalSeparator=","
            allowedDecimalSeparators={[",", "."]}
            customInput={TextField}
            fullWidth
            size="small"
            variant="outlined"
            placeholder={placeholder}
            value={selectedValue}
            onValueChange={(values) => {
              handleChangeValue({
                target: { value: values.value },
              });
            }}
            disabled={disabled}
          />
        )}
      </Box>
      <Box flex={1}>
        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{ height: "100%" }}
          onClick={handleAdd}
          disabled={buttonDisabled !== undefined ? buttonDisabled : disabled}
        >
          {buttonLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default QuinInputNum;
